import React from "react";
import { Row, Col, Button, Input } from "antd";

import { getDownloadAcceptanceForm } from 'api/api'


export default class CustomerAcceptanceForm extends React.Component {

  handleDownload = () => {
    window.open(getDownloadAcceptanceForm(), '_blank')
  }

  render() {
    const { corporateAccount, corporateAccountUsers } = this.props

    return (
      <div class="form--customer-acceptance">
        <h2>General Business Information</h2>

        <Row>
          <Col span={12}>
            <label>Business Legal Name</label>
            <input value={corporateAccount.nameOfBusiness} disabled/>
          </Col>
          <Col span={12}>
            <label>Business Registration Number</label>
            <input value={corporateAccount.businessRegistrationNumber} disabled/>
          </Col>
        </Row>

        <Row>
          <Col span={12}>
            <label>Country</label>
            <input value={corporateAccount.country} disabled/>
          </Col>
          <Col span={12}>
            <label>Business Registration Date</label>
            <input value={corporateAccount.businessRegistrationDate} disabled/>
          </Col>
        </Row>

        <Row>
          <Col span={12}>
            <label>Business Registered Address</label>
            <input value={corporateAccount.registeredAddress} disabled/>
          </Col>
          <Col span={12}>
            <label>
              Business Trading Address
              <small>(if different from registered address)</small>
            </label>
            <input value={corporateAccount.tradingAddress} disabled/>
          </Col>
        </Row>

        <Row>
          <Col span={12}>
            <label>Business Phone Number</label>
            <input value={corporateAccount.telephone} disabled/>
          </Col>
          <Col span={12}>
            <label>Business Website</label>
            <input value={corporateAccount.website} disabled/>
          </Col>
        </Row>

        <Row>
          <Col span={8}>
            <label>Source of Funds</label>
            <input value={corporateAccount.sourceOfFunds} disabled/>
          </Col>
          <Col span={8}>
            <label>Industry Code</label>
            <input value={corporateAccount.industry} disabled/>
          </Col>
          <Col span={8}>
            <label>Ownership and structure layer</label>
            <input value={""} disabled/>
          </Col>
        </Row>

        <Row>
          <Col span={12}>
            <label>Place of incorporation</label>
            <input value={""} disabled/>
          </Col>
          <Col span={12}>
            <label>Country of Operations</label>
            <input value={""} disabled/>
          </Col>
        </Row>

        <h3>Contact 1</h3>
        <Row>
          <Col span={8}>
            <label>Full Name</label>
            <input value={""} disabled/>
          </Col>
          <Col span={4}>
            <label>Title</label>
            <input value={""} disabled/>
          </Col>
          <Col span={4}>
            <label>Phone Number</label>
            <input value={""} disabled/>
          </Col>
          <Col span={4}>
            <label>Fax</label>
            <input value={""} disabled/>
          </Col>
          <Col span={4}>
            <label>Email</label>
            <input value={""} disabled/>
          </Col>
        </Row>

        <h3>Contact 2</h3>
        <Row>
          <Col span={8}>
            <label>Full Name</label>
            <input value={""} disabled/>
          </Col>
          <Col span={4}>
            <label>Title</label>
            <input value={""} disabled/>
          </Col>
          <Col span={4}>
            <label>Phone Number</label>
            <input value={""} disabled/>
          </Col>
          <Col span={4}>
            <label>Fax</label>
            <input value={""} disabled/>
          </Col>
          <Col span={4}>
            <label>Email</label>
            <input value={""} disabled/>
          </Col>
        </Row>

        <h2>Type of Institution</h2>
        <Row>
          <Col span={12}>
            <div class="row--action">
              <Input type="checkbox" />
              <label class="inline">Sole Proprietorship</label>
            </div>
          </Col>
          <Col span={12}>
            <div class="row--action">
              <Input type="checkbox" />
              <label class="inline">Corporation</label>
            </div>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <div class="row--action">
              <Input type="checkbox" />
              <label class="inline">Public Company Ticker/Symbol</label>
            </div>
          </Col>
          <Col span={12}>
            <div class="row--action">
              <Input type="checkbox" />
              <label class="inline">Others</label>
            </div>
          </Col>
        </Row>

        <h2>Corporate Related Persons Documentation Requirement</h2>
        {corporateAccountUsers.map(user => (
          <>
            <Row>
              <Col span={7}>
                <label>Full Name</label>
                <input value={`${user.firstName} ${user.lastName}`} disabled />
              </Col>
              <Col span={5}>
                <label>Gender</label>
              </Col>
              <Col span={12}>
                <label>Required Documents</label>
              </Col>
            </Row>
            <Row>
              <Col span={10}>
                <label>Expiry date of Identification document (If applicable)</label>
                <input  />
              </Col>
              <Col span={14}>
                <label>Role</label>
                <input />
              </Col>
            </Row>
            <Row>
              <Col span={6}>
                <label>Unique ID number</label>
                <input type="" />
              </Col>
              <Col span={6}>
                <label>Date of birth</label>
                <input type="" />
              </Col>
              <Col span={6}>
                <label>Nationality</label>
                <input value={user.nationality} disabled />
              </Col>
              <Col span={6}>
                <label>Country of residence</label>
                <input type="" />
              </Col>
            </Row>
            <Row>
              <Col span={18}>
                <label>Address</label>
                <input value={`${user.addressLine1 || ''} ${user.addressLine2 || ''}`} disabled />
              </Col>
              <Col span={6}>
                <label>Contact Number</label>
                <input type="" />
              </Col>
            </Row>
          </>
        ))}

        <Row>
          <div class="row--action align-center">
            <p>
              <Input type="checkbox"/>
              {" "}I verify that the information in this form is true, complete and accurate
            </p>
            <p>
              <Button type="primary">Verify</Button>
              <Button type="primary" onClick={this.handleDownload}>Download</Button>
            </p>
            <p>
              Do you need to change anything? Contact us
            </p>
          </div>
        </Row>
      </div>
    )
  }
}
